import { render, staticRenderFns } from "./ModalGeneral.vue?vue&type=template&id=17396bb6"
import script from "./ModalGeneral.vue?vue&type=script&lang=js"
export * from "./ModalGeneral.vue?vue&type=script&lang=js"
import style0 from "./ModalGeneral.vue?vue&type=style&index=0&id=17396bb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports